import React, { useCallback, useContext } from 'react';
import { FormModal, InputField } from '@ubeya/shared-web/components';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';
import useToaster from '@ubeya/shared/hooks/useToaster';
import { required } from '@ubeya/shared/utils/form';
import { createXeroContact } from '@ubeya/shared/services/api/accounts-xero';
import { xeroCreatedContactFromPostBody } from '@ubeya/shared/utils/xeroInvoicing';
import { isMobileOnly } from 'react-device-detect';

// whitespace-only input is invalid
const requiredTrimmed = (value) => required(typeof value === 'string' ? value.trim() : value);

const AddXeroInvoicingContactModal = ({ accountId, onClose, onSuccess }) => {
  const { t } = useContext(ConfigContext);
  const { addResponseError } = useToaster();

  const onSubmit = useCallback(
    async (values) => {
      const name = values?.name?.trim();
      if (!name) {
        return { name: 'required' };
      }
      try {
        const body = await createXeroContact({ accountId, name });
        const created = xeroCreatedContactFromPostBody(body);
        onSuccess(created?.name ?? name);
        onClose();
      } catch (err) {
        addResponseError(err);
      }
    },
    [accountId, addResponseError, onClose, onSuccess]
  );

  return (
    <FormModal
      initialValues={{ name: '' }}
      onSubmit={onSubmit}
      onClose={onClose}
      title={t('addNewClient')}
      confirmText={t('save')}
      showCancelButton
      size={isMobileOnly ? 'full' : 'small'}
      isScrollableContent>
      <InputField
        name="name"
        title={t('invoicingSettings__registeredNameForInvoicing')}
        validate={requiredTrimmed}
        autoFocus
      />
    </FormModal>
  );
};

export default AddXeroInvoicingContactModal;
